<template>
  <Itinerary />
</template>

<script setup lang="ts">
import Itinerary from '@/wabunka-src/features/Itinerary/pages/Itinerary/Itinerary.vue';

// 体験詳細ページと同レイアウトを使用（レイアウトファイルではなくページファイルでヘッダーを設定）
definePageMeta({ layout: 'en-experience-id' });
</script>
